import { useMutation } from '@tanstack/react-query'
import { getAiRecommendProductShortTitle } from 'service/list'

function useGetAiRecommendProductShortTitle() {
  return useMutation({
    mutationKey: ['get-ai-recommend-product-short-title'],
    mutationFn: getAiRecommendProductShortTitle,
  })
}

export default useGetAiRecommendProductShortTitle
